<template>
  <IQOS :readonly="editing" :title="$t('settings_cafe.social.title')">
    <BaseInput
      v-model="social.instagram"
      :readonly="!editing"
      :placeholder="$t('settings_cafe.social.instagram')"
    />
    <BaseInput
      class="iqos-group-item"
      v-model="social.facebook"
      :readonly="!editing"
      :placeholder="$t('settings_cafe.social.facebook')"
    />
    <p
      class="comment c-grey"
    >{{$t('settings_cafe.social.desc')}}</p>

    <IQOSActions :editing="editing" @edit="showEditUI" @cancel="hideEditUI" @accept="onEditFinish" />
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import IQOSActions from "@/components/IQOSActions.vue";

import BlackInput from "@/components/BlackInput.vue";

export default {
  components: {
    IQOS,
    IQOSActions,
    BlackInput
  },
  data() {
    return {
      social: {
        instagram: null,
        facebook: null
      },
      editing: false
    };
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    onEditFinish() {
        this.$store.commit('setCafeSocial', this.social);
        this.$store.dispatch('saveCafe');

        this.editing = false;

        this.$store.dispatch("auditlog/write", {
        type: "social_links",
        payload: this.social
      });
    },
    reset() {
      if (this.cafe.social) {
        this.social = this.cafe.social;
      }
    }
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    }
  },
  mounted() {
    this.reset();
  }
};
</script>

<style>
</style>